import React from "react";
import Button from "../form/Button";
import Papa from "papaparse";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import { Fragment } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Pdfs from "../../pdfs/Pdfs";

const CsvPdfDownload = ({
  csvData,
  pdfData,
  pdfType,
  filename = "untitled",
  buttonLabel,
  showPdf = true,
  showCsv = true,
}) => {
  // Function to generate CSV from data
  const generateCSV = () => {
    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.csv`;
    link.click();
  };

  return (
    <div>
      <Popover className="relative">
        {({ open }) => (
          <>
            <PopoverButton
              className={`font-CanelaDeck relative overflow-hidden flex justify-center items-center gap-2 bg-chestnut-rose text-white rounded-md text-base h-10 py-0 px-3 transition-all duration-200 hover:bg-blue-zodiac !bg-transparent border border-transparent hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10`}
            >
              <span className="text-sm font-medium text-chestnut-rose">
                {buttonLabel || "Download (CSV/PDF)"}
              </span>
            </PopoverButton>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <PopoverPanel className="absolute z-10 mt-2 w-64">
                <div className="overflow-hidden flex items-center justify-center gap-2 rounded-lg shadow-lg ring-1 ring-black/5 p-4 bg-white">
                  {showPdf && (
                    <PDFDownloadLink
                      document={<Pdfs data={pdfData} type={pdfType} />}
                      fileName="Eligibility-quiz.pdf"
                    >
                      {({ loading }) => (
                        <Button
                          buttonClasses={"h-8"} // Add any other classes as needed
                          buttonLabelClasses={"!text-xs"} // Add label-specific styles
                          buttonLabel={
                            loading ? "Loading document..." : "Download PDF"
                          } // Dynamic button label
                        />
                      )}
                    </PDFDownloadLink>
                  )}

                  {/* CSV Download Button */}
                  {showCsv && (
                    <Button
                      buttonClasses={"h-8"} // Add any other classes as needed
                      buttonLabelClasses={"!text-xs"} // Add label-specific styles
                      buttonLabel={"Download CSV"} // Static button label
                      buttonFunction={generateCSV} // Function to generate CSV file
                    />
                  )}
                </div>
              </PopoverPanel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default CsvPdfDownload;
